/* global window */
/* eslint prefer-template:0 */

import isSuspectedBot from './lib/viewer/isSuspectedBot.js' // This should be before the Polyfill
import './lib/viewer/bindPolyfill.js' // eslint-disable-line sort-imports

import PackagesUtil from './lib/common/PackagesUtil.js'
import _convertSiteModel from './lib/viewer/convertSiteModel.js'
import _render from './lib/viewer/render.js'
import addExperimentsFromQuery from './lib/common/addExperimentsFromQuery.js'
import applyPackagesCache from './lib/common/applyPackagesCache.js'
import getFullRjsConfig from './lib/common/getFullRjsConfig.js'
import getQueryUtils from './lib/common/getQueryUtils.js'
import getSubdomain from './lib/common/getSubdomain.js'
import instruments from './lib/viewer/instruments.js'
import joinURL from './lib/common/joinURL.js'
import mobile from './lib/viewer/mobile.js'
import overrideScriptsLocationMapFromQuery from './lib/common/overrideScriptsLocationMapFromQuery.js'
import requirejs from 'requirejs'
import resourcePrefetch from './lib/viewer/resourcePrefetch.js'
import rjsConfig from './lib/viewer/rjs-config.js'
import storageUtil from './lib/common/storageUtil.js'
import utils from './lib/viewer/utils.js'

const options = require('json!./options/viewer.json')

window.persistent = storageUtil(window) // TODO: how is this used?
const queryUtil = getQueryUtils(window)
window.queryUtil = queryUtil

// Preload scripts for caching
const prefetch = window.isPrefetchMode ||
  window.location.pathname.indexOf('prefetch') > 0 ||
  queryUtil.isParameterTrue('prefetch')

const rendererModel = window.rendererModel
const render = _render(window, requirejs, prefetch)
const packagesUtil = new PackagesUtil(options.packages, window.location.search)
const getViewerRjsConfig = rjsConfig(window, options.versions)
const { sendErrorOrQueue, instrument } = instruments(window, requirejs, isSuspectedBot, prefetch)
const convertSiteModel = _convertSiteModel(window, sendErrorOrQueue)
const isPreview = queryUtil.isParameterTrue('isEdited')
const isServerSide = !(window.clientSideRender || window.location.hash || isPreview)

const wixBiSession = window.wixBiSession || {}
window.wixBiSession = wixBiSession
wixBiSession.mainLoaded = Date.now()
wixBiSession.et = 1

const publicModel = window.publicModel
const serviceTopology = window.serviceTopology || {}
serviceTopology.scriptsLocationMap = overrideScriptsLocationMapFromQuery(serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'))

rendererModel.runningExperiments = addExperimentsFromQuery(rendererModel.runningExperiments, queryUtil, 'viewer')
const isOpen = utils.initExperimentTest(rendererModel.runningExperiments)

window.siteModel = convertSiteModel(rendererModel, publicModel)
const siteModel = window.siteModel

const pageInfo = publicModel && utils.getPageInfo(window, publicModel.pageList)

instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo)

let contentCache = function () {} //eslint-disable-line func-style
const dynamicModel = null
if (publicModel && !queryUtil.isParameterTrue('prefetch')) {
  const resourcePrefetchOptions = {
    siteModel,
    publicModel,
    pageInfo,
    shouldTimeout: isOpen('pageRequestTimeout'),
    wixBiSession,
    dynamicModel,
    isServerSide
  }
  contentCache = resourcePrefetch(window, resourcePrefetchOptions)
}

if (window.karmaIntegration) {
  siteModel.documentServicesModel = siteModel.documentServicesModel || window.karmaIntegration.documentServicesModel
  siteModel.wixapps = siteModel.wixapps || {}
  siteModel.wixapps.appbuilder = siteModel.wixapps.appbuilder || {}
  siteModel.wixapps.appbuilder.descriptor = siteModel.wixapps.appbuilder.descriptor || {}
  siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion = siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion || {}
}

const config = getFullRjsConfig(
  'santa',
  window.santaBase,
  getViewerRjsConfig(serviceTopology),
  packagesUtil,
  serviceTopology
)

if (rendererModel.runningExperiments.packagescache === 'new') {
  if (!options.disablePackagesCache) {
    applyPackagesCache({
      proj: 'santa',
      paths: config.paths,
      manifest: options.manifest,
      version: options.version,
      scriptsDomainUrl: window.serviceTopology.scriptsDomainUrl
    })
  }
}

siteModel.santaBase = config.baseUrl
serviceTopology.staticServerFallbackUrl = serviceTopology.staticServerFallbackUrl || 'https://fallback.wix.com/'
const semverMatches = siteModel.santaBase.match(/\/(\d+\.\d+\.\d+)\/?$/)
siteModel.baseVersion = semverMatches && semverMatches[1]
siteModel.santaBaseFallbackUrl = siteModel.baseVersion ? joinURL(serviceTopology.staticServerFallbackUrl, siteModel.baseVersion) : null

requirejs.config(config)

try {
  window.document.domain = getSubdomain(window.document.domain)
} catch (e) {
      // empty
}

window.isPreview = queryUtil.isParameterTrue.bind(null, 'isEdited')
const isExternalPreview = rendererModel.previewMode
const mobileView = mobile.isMobileView(window, siteModel, queryUtil)

render(isServerSide, isPreview, isExternalPreview, contentCache, queryUtil, siteModel, wixBiSession, mobileView, dynamicModel, config)
wixBiSession.beat(4)



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/viewer.js